<div style="height: calc(90vh - 50px)">
    <!-- <div *ngIf="!hideDocList && !isBatchCategorization && noDocuments">
        <div class="card-body">
            <button class="actionButton" mat-raised-button (click)="uploadCaptureDocument()">
                <mat-icon>cloud_upload</mat-icon> Upload
            </button>
            <button
                      mat-stroked-button
                      class="btn btn-small"
                      title="refresh"
                      (click)="refresh()"
                      style="float: right"
                    >
                <mat-icon title="refresh">refresh</mat-icon>
            </button>
            <div class="text-center">
                No documents to display.
            </div>
        </div>
    </div> -->
    <!-- <div *ngIf="!hideDocList && !isBatchCategorization && !noDocuments"> -->
    <div>
        <div class="filtercontainer row">
            <!-- <button style="vertical-align: middle;" class="actionButton col-1" mat-raised-button (click)="uploadCaptureDocument()">
                <mat-icon>cloud_upload</mat-icon> Upload
            </button> -->
            <!-- <div class="btn btn-small"></div>
            <button style="vertical-align: middle;" class="actionButton col-1" mat-raised-button (click)="createNewFolder()">
                <mat-icon>create_new_folder</mat-icon> Add Folder
            </button> -->
            <div class="btn btn-small"></div>
            <button
                      mat-stroked-button
                      class="btn btn-small"
                      title="refresh"
                      (click)="refresh()"
                      style="vertical-align: middle;"
                    >
                <mat-icon title="refresh">refresh</mat-icon>
            </button>
             <!-- <mat-form-field style="vertical-align: middle;" class="element-filter" *ngIf="docLength > 0">
                <mat-label>Filter</mat-label>
                <input matInput [(ngModel)]="filterInput" (keyup)="applyFilter()">
            </mat-form-field> -->
            <div class="input-group-sm mt-1 input-group col-6" style="vertical-align: middle;">
                <input class="form-control" type="search" [(ngModel)]="filterInput"
                    (keyup)="applyFilter()" (search)="applyFilter()" placeholder="Filter files">
            </div>
            <!-- <mat-icon style="vertical-align: middle;" (click)="clearFilter()">close</mat-icon> -->
            <!-- <span class="fill-remaining-space col-2"></span>
            <button style="vertical-align: middle;" class="menuButton col-1" *ngIf="selection.selected.length>0" mat-stroked-button #authMenu
                [matMenuTriggerFor]="menu">Actions
                <mat-icon>arrow_drop_down</mat-icon>
            </button>            
            <mat-menu class="my-menu" #menu="matMenu">
                <button mat-menu-item (click)="assignCategory()">Assign Metadata</button>
                <button mat-menu-item [matMenuTriggerFor]="assignOwner">Assign Owner</button>

            </mat-menu>
            <mat-menu #assignOwner="matMenu">
                <button mat-menu-item *ngFor="let group of groupList" [value]="group"
                    (click)="assign(group)"><mat-icon>groups</mat-icon>{{group}}</button>
                    <button mat-menu-item *ngFor="let user of usersList" [value]="user"
                    (click)="assign(user)"><mat-icon>person</mat-icon>{{user}}</button>
            </mat-menu> -->
        </div>

        <div class="card assign-success" *ngIf="assigned" style="text-align: center;">
            <div class="card-body">
                Documents have been assigned to <strong>{{owner}}</strong> successfully.
                <button class="button-class mt-2" mat-stroked-button (click)=back()>Close</button>
            </div>
        </div>
        <div class="container-fluid">
            <app-folder-view></app-folder-view>
            <!-- <div class="table-border">
                <table mat-table [dataSource]="docsList" matSort aria-describedby="files-table">
                    

                    <ng-container matColumnDef="select">
                        <th id="select" mat-header-cell *matHeaderCellDef>

                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(element) : null"
                                [checked]="selection.isSelected(element)" [aria-label]="checkboxLabel(element)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="srNum">
                        <th id="serialNum" mat-header-cell *matHeaderCellDef > # </th>
                        <td mat-cell *matCellDef="let element;let i=index">
                            {{ (i+1) + (myPaginator.pageIndex * myPaginator.pageSize) }} </td>
                    </ng-container>
                    <ng-container matColumnDef="file_name">
                        <th id="file-name" mat-header-cell *matHeaderCellDef mat-sort-header> File Name </th>
                        <td mat-cell *matCellDef="let element"> {{element.file_name}} </td>
                    </ng-container>
                    <ng-container matColumnDef="create_date">
                        <th id="create-date" mat-header-cell *matHeaderCellDef mat-sort-header> Uploaded Date </th>
                        <td mat-cell *matCellDef="let element"> {{element.create_date | date}} </td>
                    </ng-container>
                    <ng-container matColumnDef="created_by">
                        <th id="created-by" mat-header-cell *matHeaderCellDef mat-sort-header> Owner </th>
                        <td mat-cell *matCellDef="let element"> {{element.owner}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="documentCols"></tr>
                    <tr mat-row *matRowDef="let row; columns: documentCols;" (click)="getDocDetails($event, row)"
                        class="element-row" [class.selected-row]="selectedRow === row"
                        (click)="selectedRow = selectedRow === row ? null : row"
                        title="Click to assign document to a category">
                    </tr>                    

                </table>
                <mat-paginator #myPaginator [pageSizeOptions]="[5,10, 20, 50]" [pageSize]="10" showFirstLastButtons>
                </mat-paginator>
            </div> -->
        </div>
    </div>
    <!-- <div class="col" *ngIf="hideDocList && !isBatchCategorization">
        <app-indexpanel [documentDetails]="documentDetails" (hideDocList)="onHideDocList($event)">
        </app-indexpanel>
    </div>
    <div *ngIf="!hideDocList && isBatchCategorization">
        <app-batch-categorization [selectedDocuments]="selectedDocuments"
            (isBatchCategorization)="onbatchCategorization($event)">
        </app-batch-categorization>
    </div> -->
</div>